import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    nav: 'mt-0.5',
    mobileBackground: 'bg-grey-90'
  },
  closeIconSize: 'md',
  linkIcon: 'chevron'
} satisfies RecursivePartial<CMSConfig['megaMenu']>
